import {
    createGlobalStyle
} from "styled-components";
import reset from "styled-reset";
import {V2_BACKGROUND_COLOR} from '../config/color';

const globalStyles = createGlobalStyle `
    
    @font-face {
        font-family: "Spoqa Han Sans";
        src: url('../assets/fonts/spoqahansanslight-webfont.woff2') format('woff2'),
            url('../assets/fonts/spoqahansanslight-webfont.woff') format('woff'),
            url('../assets/fonts/SpoqaHanSansLight.ttf') format('truetype');
        font-style: normal;
        font-weight: normal;
    }

    @font-face {
        font-family: "Spoqa Han Sans";
        font-style: normal;
        src: url('../assets/fonts/spoqahansansregular-webfont.woff2') format('woff2'),
            url('../assets/fonts/spoqahansansregular-webfont.woff') format('woff'),
            url('../assets/fonts/SpoqaHanSansRegular.ttf') format('truetype');
        font-style: normal;
        font-weight: normal;
    }

    @font-face {
        font-family: "Spoqa Han Sans";
        src: url('../assets/fonts/spoqahansansbold-webfont.woff2') format('woff2'),
            url('../assets/fonts/spoqahansansbold-webfont.woff') format('woff'),
            url('../assets/fonts/SpoqaHanSansBold.ttf') format('truetype');
        font-style: normal;
        font-weight: normal;       
    }
    /* 나눔스퀘어 */
    @font-face {
        font-family: 'NanumSquare';
        font-style: normal;
        font-weight: 900;
        src: url('../assets/fonts/NanumSquareExtraBold.ttf') format('truetype');
    }

    @font-face {
        font-family: 'NanumSquare';
        font-style: normal;
        font-weight: 600;
        src: url('../assets/fonts/NanumSquareBold.ttf') format('truetype');
    }

    @font-face {
        font-family: 'NanumSquare';
        font-style: normal;
        font-weight: 400;
        src: url('../assets/fonts/NanumSquareRegular.ttf') format('truetype');
    }


    ${reset};
    a {
        text-decoration: none;
        color: inherit;
    }
    * {
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
    }
    html {
        min-height: 100vh;
    }
    body {
        font-family: 'NanumSquare', 'Spoqa Han Sans', -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        font-weight: 400;
        font-size: 14px;
        /* padding-top: 60px; */
        background-color: ${V2_BACKGROUND_COLOR} !important;
        @media (max-width: 768px) {
            /* padding-top: 80px;
             */
        }
    }

    h1,
    h2,
    b {
        font-weight: 600;
    }
    
    input,
    button {
        border: none;
        &:focus {
            outline: none;
        }
    }

    button {
        cursor: pointer;
        
    }


`;

export default globalStyles;